import { createReducer } from '@reduxjs/toolkit';
import { IBankInformation } from 'app/interfaces/user/bank-information.interface';
import { ILoginState } from '../../interfaces/reducer-interface/login.interface';
import {
	getLoginAction,
	setLoginErrorAction,
	setLoginAction,
	setLoginSuccessAction,
	setCheckPasswordAction,
	setCheckPasswordErrorAction,
	checkPasswordAction,
} from '../actions/LoginAction';

const bankInformation: IBankInformation = {
	bankAccount: '',
	bankAccountPayroll: '',
	bankBranch: '',
	bankCode: '',
	bankName: '',
	bankUrlImage: '',
	methodPayment: 0,
};

const initialState: ILoginState = {
	loading: false,
	user: {
		bankInformation,
		digiSignId: '',
		email: '',
		phoneNumber: '',
		token: '',
		userId: '',
		userName: '',
		userTypeId: 0,
		userTypeName: ''
	},
	loginParam: {
		phoneNumber: '',
		password: '',
		type: 'lender',
	},
	error: '',
	message: '',
	errorCheckPassword: '',
	isValidated: false,
};

const loginReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(getLoginAction, (state, action) => ({
			...state,
			loading: true,
			loginParam: action.payload,
		}))
		.addCase(setLoginAction, (state, action) => ({
			...state,
			loading: true,
			user: action.payload,
		}))
		.addCase(setLoginSuccessAction, (state, action) => ({
			...state,
			loading: false,
			message: action.payload,
		}))
		.addCase(setLoginErrorAction, (state, action) => ({
			...state,
			error: action.payload,
		}))
		.addCase(checkPasswordAction, (state) => ({
			...state,
		}))
		.addCase(setCheckPasswordAction, (state, action) => ({
			...state,
			isValidated: action.payload,
		}))
		.addCase(setCheckPasswordErrorAction, (state, action) => ({
			...state,
			errorCheckPassword: action.payload,
		}))
		.addDefaultCase((state) => ({ ...state }));
});

export default loginReducer;
